<template>
	<booking :data="booking" :summary="true" v-if="booking !== null" />
</template>

<script>
import { mapGetters } from 'vuex'
import Booking from '~/views/components/booking'
// import bookingMixin from '../mixins/booking.mixin'

export default {
	name: 'Summary',

	components: { Booking },

	computed: mapGetters({
		id: 'booking/id',
		bookingId: 'booking/bookingId',
	}),

	data() {
		return {
			booking: null,
		}
	},

	async created() {
		if (!this.bookingId) {
			// eslint-disable-next-line no-unused-vars
			this.$router.push({ name: 'booking' }).catch((e) => {})
			return
		}

		try {
			let { data } = await this.$http.get(`/bs/${this.id}/${this.bookingId}`)
			this.booking = data
			this.$store.commit('booking/DEL_BOOK')
		} catch ({ response }) {
			// eslint-disable-next-line no-unused-vars
			this.$router.push({ name: 'booking' }).catch((e) => {})
		}
	},
}
</script>
